import {ISelectOption, SharedRangeDatePickerValue} from '@frontend/shared';
import {FilterRangeModel, FiltersModel, ProposalModel, SectionItemModel} from '../interfaces';
import {DateTime} from '@gravity-ui/date-utils';

export function getFiltered(sourceCollection: SectionItemModel[], filters: FiltersModel) {
    const filteredCollection: SectionItemModel[] = [];

    for (const item of sourceCollection) {
        const sProposals: ProposalModel[] = [];
        for (const p of item.proposals) {
            if (isMatchProposal(p, filters)) sProposals.push(p);
        }

        if (sProposals.length > 0) filteredCollection.push({...item, proposals: sProposals});
    }

    return filteredCollection;
}

function isMatchProposal(proposal: ProposalModel, filtersParam: FiltersModel) {
    if (!isSourceMatched(proposal.source, filtersParam.source)) {
        return false;
    }
    if (
        !isSupplierMatched(proposal.webSupplierName, proposal.supplierName, filtersParam.supplier)
    ) {
        return false;
    }
    if (!isMatchRange(filtersParam.ratingRange, proposal.rating)) return false;
    if (!isMatchRange(filtersParam.quantityRange, proposal.quantity)) return false;
    if (!isMatchRange(filtersParam.multiplicityRange, proposal.multiplicity)) return false;
    if (!isMatchRange(filtersParam.deliveryDaysRange, proposal.deliveryDays)) return false;
    if (!isMatchDateRange(filtersParam.deliveryDateRange, proposal.deliveryDate)) return false;
    if (filtersParam.isReturnPossible && !proposal.isReturnPossible) return false;
    if (filtersParam.isOfficialDealer && !proposal.isOfficialDealer) return false;

    return true;
}

function isMatchRange(range: FilterRangeModel, value: number) {
    if (range.min !== undefined && value < range.min) return false;
    if (range.max !== undefined && value > range.max) return false;
    return true;
}

function isMatchDateRange(range: SharedRangeDatePickerValue, value: DateTime | null | Date) {
    if (!value) return false;
    const {start, end} = range;

    if (start && value < start) return false;
    if (end && value > end) return false;

    return true;
}

function isSupplierMatched(
    webSupplierName: string,
    supplierName: string,
    supplierOptions: ISelectOption[]
) {
    const anySelected = supplierOptions.some((s) => s.isSelected);
    if (!anySelected) {
        return true;
    }

    const found = supplierOptions.find(
        (s) => s.isSelected && (s.value === webSupplierName || s.value === supplierName)
    );

    return !!found;
}

function isSourceMatched(proposalSource: string, sourceOptions: ISelectOption[]) {
    const anySelected = sourceOptions.some((s) => s.isSelected);
    if (!anySelected) {
        return true;
    }

    const found = sourceOptions.find(
        (opt) => opt.value.toLowerCase() === proposalSource?.toLowerCase()
    );

    if (!found || !found.isSelected) {
        return false;
    }

    return true;
}
